import { render, staticRenderFns } from "./yearCounter.vue?vue&type=template&id=0996bfe4&scoped=true"
import script from "./yearCounter.vue?vue&type=script&lang=js"
export * from "./yearCounter.vue?vue&type=script&lang=js"
import style0 from "./yearCounter.vue?vue&type=style&index=0&id=0996bfe4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0996bfe4",
  null
  
)

export default component.exports